"use client";

import { useEffect } from "react";
import { reportError } from "@/lib/telemetry";

/**
 * The root layout itself threw. Next renders this in place of the whole document,
 * so it brings its own <html> and <body>.
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportError(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ display: "flex", minHeight: "100vh", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, padding: 24, textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
          <h2 style={{ fontSize: 18, fontWeight: 600 }}>Genesis ran into a problem.</h2>
          <p style={{ fontSize: 14, color: "#4b5563" }}>It has been reported. Try reloading the page.</p>
          <button type="button" onClick={reset} style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "6px 12px", fontSize: 14 }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
